export default "__VITE_ASSET__2aefe842__"